import React, {useEffect, useState} from 'react';
import moment from "moment";
import './ParametresObjectifs.scss';
import {Alert, Button, Form} from "react-bootstrap";
import axios from "axios";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

const ParametresObjectifsDate = (props) => {
    const ModalObject = withReactContent(Swal);
    axios.defaults.headers.common['Authorization'] = 'Bearer '+props.ent;
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1); // Mois de 1 à 12
    const [days, setDays] = useState([]);
    const [inputs, setInputs] = useState([]);
    const [validationMessage, setValidationMessage] = useState('')

    useEffect(() => {
        setValidationMessage('');

        const daysInMonth = moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();
        const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);
        setDays(daysArray);

        axios.post(process.env.REACT_APP_API_URL +'/api/objectif/getAllObjectifsTotem', {
           id: props.data.id
        }).then(response => {

            const initialInputs = daysArray.map(day => {
                const dateStr = moment(`${year}-${month}-${day}`, 'YYYY-M-D').format('YYYY-MM-DD');
                const existingData = response.data.find(item => item.obj_date === dateStr);
                return {
                    date: dateStr,
                    value: existingData ? existingData.obj_objectif : null,
                };
            });
            setInputs(initialInputs);

        }).catch(error => {
            console.error('Error fetching data:', error);
        });

    }, [year, month]);

    const handleYearChange = (e) => {
        setYear(parseInt(e.target.value));
        setInputs([])
    }
    const handleMonthChange = (e) => {
        setMonth(parseInt(e.target.value));
        setInputs([])
    }

    const months = Array.from({ length: 12 }, (_, i) => i + 1);
    const years = Array.from({ length: 20 }, (_, i) => i + 2020);

    const handleInputChange = (day, value) => {
        const dateStr = moment(`${year}-${month}-${day}`, 'YYYY-M-D').format('YYYY-MM-DD');
        setInputs((prevInputs) => {
            return prevInputs.map(input =>
                input.date === dateStr ? {...input, value} : input
            );
        });
    };

    const replicateValue = (day) => {
        const dateStr = moment(`${year}-${month}-${day}`, 'YYYY-M-D').format('YYYY-MM-DD');
        const inputToReplicate = inputs.find(input => input.date === dateStr);
        if (inputToReplicate) {
            const valueToReplicate = inputToReplicate.value;
            setInputs((prevInputs) => {
                return prevInputs.map(input =>
                    moment(input.date).isAfter(dateStr) ? {...input, value: valueToReplicate} : input
                );
            });
        }
    };

    const getInputValue = (day) => {
        const dateStr = moment(`${year}-${month}-${day}`, 'YYYY-M-D').format('YYYY-MM-DD');
        const input = inputs.find(input => input.date === dateStr);
        return input ? input.value : '';
    };

    const formatDate = (day) => {
        const date = moment(`${year}-${month}-${day}`, 'YYYY-M-D');
        return date.locale('fr').format('dddd DD/MM/YYYY');
    };
    
    const handleValidateObjectifs = () => {
        setValidationMessage('');
        if (inputs){
            axios.post(process.env.REACT_APP_API_URL +'/api/objectif/addObjTotem', {
                id: props.data.id,
                data: inputs
            }).then(response => {
                setValidationMessage('Objectifs enregistrés avec succès')
            }).catch(error => {
                console.error('Error fetching data:', error);
            });
        }
    }

    console.log('data ', props.data);

    console.log('input ', inputs)

    return (
        <div>
            <header className="header">

                <div className="header-title">
                    <h1>Objectifs {props.data.name}</h1>
                </div>
                <div className="header-filters">
                    <label>
                        Année :
                        <select value={year} onChange={handleYearChange}>
                            {years.map((y) => (
                                <option key={y} value={y}>
                                    {y}
                                </option>
                            ))}
                        </select>
                    </label>
                    <label>
                        Mois :
                        <select value={month} onChange={handleMonthChange}>
                            {months.map((m) => (
                                <option key={m} value={m}>
                                    {moment().month(m - 1).format('MMMM')}
                                </option>
                            ))}
                        </select>
                    </label>
                </div>
            </header>
            <table className="table">
                <thead>
                <tr>
                    <th>Jour</th>
                    <th>Objectif</th>
                </tr>
                </thead>
                <tbody>
                {days.map((day) => (
                    <tr key={day} className="table-row">
                        <td><span>{formatDate(day)}</span></td>
                        <td style={{display: 'flex'}}>
                            <Form.Control type={"text"}
                                          value={getInputValue(day)}
                                          onChange={(e) => handleInputChange(day, e.target.value)}
                            />
                            <button onClick={() => replicateValue(day)}>Replicate</button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>

            {
                validationMessage ? (
                    <Alert variant={"success"}>{validationMessage}</Alert>
                ) : null
            }
            <div style={{display: "flex", justifyContent: "space-between", marginTop: '2em'}}>
                <Button variant={"success"} onClick={handleValidateObjectifs}>Valider les objectifs</Button>
                <Button variant={"secondary"} onClick={() => ModalObject.close()}>Fermer</Button>
            </div>
        </div>
    );
};

export default ParametresObjectifsDate;